// @flow

import React, { type Node, createContext, useContext, useMemo } from 'react';
import { type AppValues } from './types';

const AppValuesContext = createContext<[AppValues, (AppValues) => void]>([{}, () => {}]);

type Props = {|
  +children: Node,
  +appValues: AppValues,
  +setAppValues: (AppValues) => void,
|};

export function AppValuesProvider({ children, appValues, setAppValues }: Props): Node {
  const contextValue = useMemo(() => [appValues, setAppValues], [appValues, setAppValues]);

  return (
    <AppValuesContext.Provider value={contextValue}>
      {children}
    </AppValuesContext.Provider>
  );
}

export function useAppValues(): [AppValues, (AppValues) => void] {
  const appValuesContext = useContext(AppValuesContext);
  if (!appValuesContext) {
    throw new Error('AppValues was not provided');
  }
  return appValuesContext;
}
